import { useReveal } from "@/hooks/useReveal";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import PainPoints from "@/components/site/PainPoints";
import Services from "@/components/site/Services";
import Comparison from "@/components/site/Comparison";
import Testimonials from "@/components/site/Testimonials";
import Stats from "@/components/site/Stats";
import SEO from "@/components/site/SEO";
// Eager-imported so renderToString emits their HTML during SSG.
// Previously lazy() + Suspense(fallback={null}) → crawlers saw empty sections.
import Process from "@/components/site/Process";
import About from "@/components/site/About";
import Location from "@/components/site/Location";
import AppSection from "@/components/site/AppSection";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

const Index = () => {
  useReveal();
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <SEO
        title="FINABLE – Steueroptimierte Finanzberatung & Altersvorsorge"
        description="Steuern sparen, staatliche Förderungen nutzen & Vermögen aufbauen. Unabhängige digitale Finanzberatung – kostenlos & bundesweit."
        canonical="https://finable.de/"
      />
      <Header />
      <main>
        <Hero />
        <PainPoints />
        <Services />
        <Comparison />
        <Testimonials />
        <Stats />
        <Process />
        <About />
        <Location />
        <AppSection />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
